import { useState, useEffect } from 'react';
import { getOutreachRecordingUri } from '@services/api';
import './RecordingPlayer.css';

// Lazily fetches a short-lived signed URL for a call recording and renders an HTML5 player.
// The URL is only requested when the user clicks "Play recording", so expanding a call never
// pulls PHI audio until it's explicitly requested. Re-clicking after expiry fetches a fresh URL.
export default function RecordingPlayer({ contactId, recordingSid }) {
  const [recordingUri, setRecordingUri] = useState(null);
  const [recordingLoading, setRecordingLoading] = useState(false);
  const [recordingError, setRecordingError] = useState(null);

  // Reset when a different call is shown in the same panel position.
  useEffect(() => {
    setRecordingUri(null);
    setRecordingError(null);
    setRecordingLoading(false);
  }, [contactId]);

  const loadRecording = async () => {
    setRecordingLoading(true);
    setRecordingError(null);
    try {
      const result = await getOutreachRecordingUri(contactId);
      if (result?.uri) {
        setRecordingUri(result.uri);
      } else {
        setRecordingError('Recording unavailable');
      }
    } catch (err) {
      console.error('Error loading recording:', err);
      setRecordingError('Recording unavailable');
    } finally {
      setRecordingLoading(false);
    }
  };

  return (
    <div className="recording-player-wrapper">
      {recordingUri ? (
        <audio controls preload="none" src={recordingUri} className="recording-player" />
      ) : (
        <button
          type="button"
          className="load-recording-button"
          onClick={loadRecording}
          disabled={recordingLoading}
        >
          {recordingLoading ? 'Loading…' : '▶ Play recording'}
        </button>
      )}
      {recordingError && <p className="recording-error">{recordingError}</p>}
      <p className="recording-sid"><strong>Recording SID:</strong> <span className="guid-text">{recordingSid}</span></p>
    </div>
  );
}
